import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bd6692a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_HeaderV2 = _resolveComponent("HeaderV2")!
  const _component_OtopackWarning = _resolveComponent("OtopackWarning")!
  const _component_EmbargoWarning = _resolveComponent("EmbargoWarning")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_CompareDownload = _resolveComponent("CompareDownload")!
  const _component_Detail = _resolveComponent("Detail")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: 
      `${
        _ctx.isSenderAccount || _ctx.isSidebarAndBreadcrumbV2 ? 'pt-4' : 'pt-8'
      } bg-white flex flex-col text-12px xxl:text-14px overflow-scroll relative w-full`
    
    }, [
      (!_ctx.isSenderAccount)
        ? (_openBlock(), _createBlock(_component_Breadcrumb, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_HeaderV2, {
        placeholderOrigin: _ctx.$t('shipmentRates.placeholderOrigin'),
        searchValueOrigin: _ctx.selectSearchOriginValue,
        selectSearchDataOrigin: _ctx.locationSearchOriginList,
        selectSearchOriginNotFound: _ctx.locationSearchOriginNotFound,
        onSelectSearchOrigin: _ctx.onSelectSearchOrigin,
        onOpenSelectSearchOrigin: _ctx.onOpenSelectSearchOrigin,
        onCloseSelectSearchOrigin: _ctx.onCloseSelectSearchOrigin,
        onChooseSelectSearchOrigin: _ctx.onChooseSelectSearchOrigin,
        statusSelectSearchOrigin: _ctx.statusSelectSearchOrigin,
        placeholderDestination: _ctx.$t('shipmentRates.placeholderDestination'),
        searchValueDestination: _ctx.selectSearchDestinationValue,
        selectSearchDataDestination: _ctx.locationSearchDestinationList,
        selectSearchDestinationNotFound: _ctx.locationSearchDestinationNotFound,
        onSelectSearchDestination: _ctx.onSelectSearchDestination,
        onOpenSelectSearchDestination: _ctx.onOpenSelectSearchDestination,
        onCloseSelectSearchDestination: _ctx.onCloseSelectSearchDestination,
        onChooseSelectSearchDestination: _ctx.onChooseSelectSearchDestination,
        statusSelectSearchDestination: _ctx.statusSelectSearchDestination,
        productData: 
        _ctx.isHiddenOnepack ? _ctx.productListDataWithoutOnePack : _ctx.productListData
      ,
        onOpenProductSelect: () => _ctx.onOpenProductSelect(true),
        onCloseProductSelect: () => _ctx.onOpenProductSelect(false),
        valueProduct: _ctx.productName,
        productSelect: _ctx.productSelect,
        onSelectProduct: _ctx.onSelectProduct,
        clientValue: _ctx.filterData.client,
        "onUpdate:clientValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterData.client = $event)),
        valueCommodity: _ctx.filterData.commodity,
        "onUpdate:valueCommodity": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterData.commodity = $event)),
        weight: _ctx.filterData.weight,
        "onUpdate:weight": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterData.weight = $event)),
        length: _ctx.filterData.length,
        "onUpdate:length": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterData.length = $event)),
        width: _ctx.filterData.width,
        "onUpdate:width": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterData.width = $event)),
        height: _ctx.filterData.height,
        "onUpdate:height": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterData.height = $event)),
        price: _ctx.filterData.price,
        "onUpdate:price": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterData.price = $event)),
        weightUnit: _ctx.weightUnit,
        "onUpdate:weightUnit": _cache[8] || (_cache[8] = ($event: any) => (_ctx.weightUnit = $event)),
        isDisabled: _ctx.isDisabled,
        onOnButtonRight: _ctx.onCompare,
        onFilter: _ctx.getData,
        labelButtonRight: _ctx.$t('shipmentRates.titleMenuDownload'),
        onOnToggleShowFilter: _ctx.setIsShowFilter
      }, null, 8, ["placeholderOrigin", "searchValueOrigin", "selectSearchDataOrigin", "selectSearchOriginNotFound", "onSelectSearchOrigin", "onOpenSelectSearchOrigin", "onCloseSelectSearchOrigin", "onChooseSelectSearchOrigin", "statusSelectSearchOrigin", "placeholderDestination", "searchValueDestination", "selectSearchDataDestination", "selectSearchDestinationNotFound", "onSelectSearchDestination", "onOpenSelectSearchDestination", "onCloseSelectSearchDestination", "onChooseSelectSearchDestination", "statusSelectSearchDestination", "productData", "onOpenProductSelect", "onCloseProductSelect", "valueProduct", "productSelect", "onSelectProduct", "clientValue", "valueCommodity", "weight", "length", "width", "height", "price", "weightUnit", "isDisabled", "onOnButtonRight", "onFilter", "labelButtonRight", "onOnToggleShowFilter"]),
      (_ctx.isAnyOtopack.isAny)
        ? (_openBlock(), _createBlock(_component_OtopackWarning, {
            key: 1,
            isNotAllProduct: _ctx.isAnyOtopack.full
          }, null, 8, ["isNotAllProduct"]))
        : _createCommentVNode("", true),
      (_ctx.isAnyEmbargo.isAny)
        ? (_openBlock(), _createBlock(_component_EmbargoWarning, {
            key: 2,
            isFullEmbargo: _ctx.isAnyEmbargo.full
          }, null, 8, ["isFullEmbargo"]))
        : _createCommentVNode("", true),
      (_ctx.isError && !_ctx.isLoading && !_ctx.isNotFound)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 3,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.onCompare
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_ctx.isEmpty)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 4,
              customMessage: _ctx.$t('shipmentRates.emptyListMessage')
            }, null, 8, ["customMessage"]))
          : (_ctx.isFilter)
            ? (_openBlock(), _createBlock(_component_TableV2, {
                key: 5,
                "is-hard-pagination": true,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[9] || (_cache[9] = ($event: any) => (_ctx.pagination = $event)),
                loading: _ctx.isLoading,
                columns: _ctx.columnsData,
                data: _ctx.listData,
                class: "my-2",
                onClick: _ctx.onClickRow,
                borderTop: false,
                isRightFreeze: "",
                totalColumnFreeze: _ctx.isBookingCreate ? 2 : 1,
                buttonAction: "",
                customButtonAction: _ctx.customButton,
                dynamicCustomButtonAction: true,
                isDetailAble: _ctx.isDetailAble,
                customClassPagination: 'relative w-full bottom-0',
                isSpaceBottom: "",
                "data-testid": "tariff-rates-check-table-result"
              }, null, 8, ["pagination", "loading", "columns", "data", "onClick", "totalColumnFreeze", "customButtonAction", "isDetailAble"]))
            : _createCommentVNode("", true),
      (_ctx.isNotAvailable)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 6,
            onSubmit: () => _ctx.onNotAvailable(false),
            title: _ctx.$t('shipmentRates.titleNotFoundRates'),
            message: _ctx.errorMessage,
            image: "image-modal-warning",
            textSuccess: "OK",
            class: "px-8"
          }, null, 8, ["onSubmit", "title", "message"]))
        : _createCommentVNode("", true),
      (_ctx.isModalSuccessDownload)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 7,
            onSubmit: () => _ctx.setModalDownload(false),
            title: _ctx.$t('shipmentRates.titleDownloadSuccess'),
            message: "",
            image: "image-modal-success",
            textSuccess: "Ok",
            class: "px-8"
          }, null, 8, ["onSubmit", "title"]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.isShowcompareTariff)
      ? (_openBlock(), _createBlock(_component_CompareDownload, {
          key: 0,
          isShow: _ctx.isShowcompareTariff,
          "onUpdate:isShow": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowcompareTariff = $event)),
          hiddenProduct: _ctx.isHiddenOnepack
        }, null, 8, ["isShow", "hiddenProduct"]))
      : _createCommentVNode("", true),
    (_ctx.isOpenDetail)
      ? (_openBlock(), _createBlock(_component_Detail, {
          key: 1,
          onClose: _ctx.onCloseDetail,
          isAnyEmbargo: _ctx.isAnyEmbargo.isAny,
          isFullEmbargo: _ctx.isAnyEmbargo.full,
          isAnyOtopack: _ctx.isAnyOtopack.isAny,
          isNotAllProduct: _ctx.isAnyOtopack.full,
          isShowButton: _ctx.isSenderAccount ? false : _ctx.showButton,
          goToBook: _ctx.goToBook,
          isSenderAccount: _ctx.isSenderAccount
        }, null, 8, ["onClose", "isAnyEmbargo", "isFullEmbargo", "isAnyOtopack", "isNotAllProduct", "isShowButton", "goToBook", "isSenderAccount"]))
      : _createCommentVNode("", true)
  ], 64))
})